export default {
  BACK: 'BACK',
  ERROR: 'ERROR',
  INVENTORY: 'INVENTORY',
  SETTINGS: 'SETTINGS',
  AUTHENTICATE: 'AUTHENTICATE',
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
  LOCK: 'LOCK',
  OTP_CODE: 'OTP_CODE',
  SETUP_2FA: 'SETUP_2FA',
  ERROR_404: 'ERROR_404',
  ERROR_403: 'ERROR_403',
  ADMIN_ERROR: 'ADMIN_ERROR',
  VAULT: 'VAULT',
  PASSWORDS: 'PASSWORDS',
  NOTES: 'NOTES',
  CARDS: 'CARDS',
  CRYPTO_BACKUPS: 'CRYPTO_BACKUPS',
  IDENTITIES: 'IDENTITIES',
  FOLDERS: 'FOLDERS',
  FOLDER_DETAIL: 'FOLDER_DETAIL',
  FOLDER_DETAIL_ITEM: 'FOLDER_DETAIL_ITEM',
  FOLDER_DETAIL_ITEM_HISTORY: 'FOLDER_DETAIL_ITEM_HISTORY',
  AUTHENTICATOR: 'AUTHENTICATOR',
  SECURITY_TOOLS: 'SECURITY_TOOLS',
  PASSWORD_HEALTH: 'PASSWORD_HEALTH',
  PASSWORD_HEALTH_WEAK_ITEM: 'PASSWORD_HEALTH_WEAK_ITEM',
  PASSWORD_HEALTH_WEAK_ITEM_HISTORY: 'PASSWORD_HEALTH_WEAK_ITEM_HISTORY',
  PASSWORD_HEALTH_REUSED_ITEM: 'PASSWORD_HEALTH_REUSED_ITEM',
  PASSWORD_HEALTH_REUSED_ITEM_HISTORY: 'PASSWORD_HEALTH_REUSED_ITEM_HISTORY',
  PASSWORD_HEALTH_EXPOSED_ITEM: 'PASSWORD_HEALTH_EXPOSED_ITEM',
  PASSWORD_HEALTH_EXPOSED_ITEM_HISTORY: 'PASSWORD_HEALTH_EXPOSED_ITEM_HISTORY',
  BREACH_SCANNER: 'BREACH_SCANNER',
  POLICIES: 'POLICIES',
  POLICIES_VIOLATED: 'POLICIES_VIOLATED',
  SHARES: 'SHARES',
  TRASH: 'TRASH',
  SETTINGS_ACCOUNT: 'SETTINGS_ACCOUNT',
  SETTINGS_IMPORT_EXPORT: 'SETTINGS_IMPORT_EXPORT',
  SETTINGS_SECURITY: 'SETTINGS_SECURITY',
  SETTINGS_NOTIFICATIONS: 'SETTINGS_NOTIFICATION',
  EMERGENCY_ACCESS_VIEW: 'EMERGENCY_ACCESS_VIEW',
  VAULT_DETAIL: 'VAULT_DETAIL',
  VAULT_HISTORY: 'VAULT_HISTORY',
  PASSWORD_DETAIL: 'PASSWORD_DETAIL',
  PASSWORD_HISTORY: 'PASSWORD_HISTORY',
  NOTE_DETAIL: 'NOTE_DETAIL',
  CARD_DETAIL: 'CARD_DETAIL',
  CRYPTO_BACKUP_DETAIL: 'CRYPTO_BACKUP_DETAIL',
  IDENTITY_DETAIL: 'IDENTITY_DETAIL',
  TRASH_DETAIL: 'TRASH_DETAIL',
  SHARED_WITH_ME: 'SHARED_WITH_ME',
  SHARED_WITH_ME_ITEM: 'SHARED_WITH_ME_ITEM',
  SHARED_WITH_ME_ITEM_HISTORY: 'SHARED_WITH_ME_ITEM_HISTORY',
  SHARED_WITH_ME_FOLDER: 'SHARED_WITH_ME_FOLDER',
  SHARED_WITH_ME_FOLDER_ITEM: 'SHARED_WITH_ME_FOLDER_ITEM',
  SHARED_WITH_ME_FOLDER_ITEM_HISTORY: 'SHARED_WITH_ME_FOLDER_ITEM_HISTORY',
  MY_SHARED_ITEMS: 'MY_SHARED_ITEMS',
  MY_SHARED_ITEMS_ITEM: 'MY_SHARED_ITEMS_ITEM',
  MY_SHARED_ITEMS_ITEM_HISTORY: 'MY_SHARED_ITEMS_ITEM_HISTORY',
  MY_SHARED_ITEMS_FOLDER: 'MY_SHARED_ITEMS_FOLDER',
  MY_SHARED_ITEMS_FOLDER_ITEM: 'MY_SHARED_ITEMS_FOLDER_ITEM',
  MY_SHARED_ITEMS_FOLDER_ITEM_HISTORY: 'MY_SHARED_ITEMS_FOLDER_ITEM_HISTORY',
  QUICK_SHARE_DETAIL: 'QUICK_SHARE_DETAIL',
  SHARE_DETAIL: 'SHARE_DETAIL',
  ENTERPRISE: 'ENTERPRISE',
  ENTERPRISES: 'ENTERPRISES',
  EMAIL_SETTINGS: 'EMAIL_SETTINGS',
  SSO_CONFIGURATION: 'SSO_CONFIGURATION',
  ENTERPRISE_DASHBOARD: 'ENTERPRISE_DASHBOARD',
  ENTERPRISE_MEMBERS: 'ENTERPRISE_MEMBERS',
  ENTERPRISE_MEMBER: 'ENTERPRISE_MEMBER',
  ENTERPRISE_GROUPS: 'ENTERPRISE_GROUPS',
  ENTERPRISE_POLICIES: 'ENTERPRISE_POLICIES',
  ENTERPRISE_ACTIVITY_LOGS: 'ENTERPRISE_ACTIVITY_LOGS',
}